<template lang="pug">
v-container.d-flex.flex-column.justify-center.align-center.pt-8
  .markdown
    h2.text-center Privacy policy

    p
    | Protecting your private information is our priority. This Statement of Privacy applies to Worxstr,
    | and Worxstr L.L.C. and governs data collection and usage. For the purposes of this Privacy
    | Policy, unless otherwise noted, all references to Worxstr L.L.C. include www.worxstr.com. The
    | Worxstr L.L.C. application is a Worxstr management platform and payment services application.
    | By using the Worxstr L.L.C. application, you consent to the data practices described in this
    | statement.

    br
    br
    h3 Collection of your Personal Information

    p
    | In order to better provide you with products and services offered, Worxstr L.L.C. may collect
    | personally identifiable information, such as your:

    ul
      li First and Last Name
      li Mailing Address
      li E-mail Address
      li Phone Number

    p
    | If you purchase Worxstr L.L.C.'s products and services, we collect billing and credit card
    | information. This information is used to complete the purchase transaction.

    p 
    | We do not collect any personal information about you unless you voluntarily provide it to us.
    | However, you may be required to provide certain personal information to us when you elect to use
    | certain products or services. These may include: (a) registering for an account; (b) entering a
    | sweepstakes or contest sponsored by us or one of our partners; (c) signing up for special offers
    | from selected third parties; (d) sending us an email message; (e) submitting your credit card or
    | other payment information when ordering and purchasing products and services. To wit, we will
    | use your information for, but not limited to, communicating with you in relation to services and/or
    | products you have requested from us. We also may gather additional personal or non-personal
    | information in the future.
    
    br
    br
    h3 Use of your Personal Information
    p 
    | Worxstr L.L.C. collects and uses your personal information to operate and deliver the services
    | you have requested.

    p 
    | Worxstr L.L.C. may also use your personally identifiable information to inform you of other
    | products or services available from Worxstr L.L.C. and its affiliates.

    br
    br
    h3 Sharing Information with Third Parties
    p 
    | Worxstr L.L.C. does not sell, rent or lease its customer lists to third parties.

    p 
    | Worxstr L.L.C. may share data with trusted partners to help perform statistical analysis, send you
    | email or postal mail, provide customer support, or arrange for deliveries. All such third parties are
    | prohibited from using your personal information except to provide these services to Worxstr
    | L.L.C., and they are required to maintain the confidentiality of your information.

    p 
    | Worxstr L.L.C. may disclose your personal information, without notice, if required to do so by law
    | or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or
    | comply with legal process served on Worxstr L.L.C. or the site; (b) protect and defend the rights
    | or property of Worxstr L.L.C.; and/or (c) act under exigent circumstances to protect the personal
    | safety of users of Worxstr L.L.C., or the public.

    br
    br
    h3 Right to Deletion
    p 
    | Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will:
    ul
      li Delete your personal information from our records; and
      li Direct any service providers to delete your personal information from their records.

    p 
    | Please note that we may not be able to comply with requests to delete your personal information if
    | it is necessary to:
    ul
      li Complete the transaction for which the personal information was collected, fulfill the
      | terms of a written warranty or product recall conducted in accordance with federal
      | law, provide a good or service requested by you, or reasonably anticipated within the
      | context of our ongoing business relationship with you, or otherwise perform a contract
      | between you and us;
      li Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal
      | activity; or prosecute those responsible for that activity;
      li Debug to identify and repair errors that impair existing intended functionality;
      li Exercise free speech, ensure the right of another consumer to exercise his or her right
      | of free speech, or exercise another right provided for by law;
      li Comply with the California Electronic Communications Privacy Act;
      li Engage in public or peer-reviewed scientific, historical, or statistical research in the
      | public interest that adheres to all other applicable ethics and privacy laws, when our
      | deletion of the information is likely to render impossible or seriously impair the
      | achievement of such research, provided we have obtained your informed consent;
      li Enable solely internal uses that are reasonably aligned with your expectations based on
      | your relationship with us;
      li Comply with an existing legal obligation; or
      li Otherwise use your personal information, internally, in a lawful manner that is
      | compatible with the context in which you provided the information.

    br
    br
    h3 Children Under Thirteen
    p 
    | Worxstr L.L.C. does not knowingly collect personally identifiable information from children under
    | the age of thirteen. If you are under the age of thirteen, you must ask your parent or guardian for
    | permission to use this application.

    br
    br
    h3 E-mail Communications
    p 
    | From time to time, Worxstr L.L.C. may contact you via email for the purpose of providing
    | announcements, promotional offers, alerts, confirmations, surveys, and/or other general
    | communication.

    p 
    | If you would like to stop receiving marketing or promotional communications via email from
    | Worxstr L.L.C., you may opt out of such communications by Currently no promotional emails are
    | exchanged between Worxstr and our users.

    br
    br
    h3 External Data Storage Sites
    p 
    | We may store your data on servers provided by third party hosting vendors with whom we have
    | contracted.

    br
    br
    h3 Changes to this Statement
    p 
    | Worxstr L.L.C. reserves the right to change this Privacy Policy from time to time. We will notify
    | you about significant changes in the way we treat personal information by sending a notice to the
    | primary email address specified in your account, by placing a prominent notice on our application,
    | and/or by updating any privacy information. Your continued use of the application and/or Services
    | available after such modifications will constitute your: (a) acknowledgment of the modified Privacy
    | Policy; and (b) agreement to abide and be bound by that Policy.

    br
    br
    h3 Contact Information
    p 
    | Worxstr L.L.C. welcomes your questions or comments regarding this Statement of Privacy. If you
    | believe that Worxstr L.L.C. has not adhered to this Statement, please contact Worxstr L.L.C. at:

    p
      br 
      span Worxstr L.L.C.
      br
      span 2207 E 7th St 
      br
      span Charlotte, North Carolina 28204

    p 
      span Email Address:
      br
      b support@worxstr.com

    p 
     span Telephone number:
     br
     b 828-726-7235 or 704-456-5750

    p Effective as of March 17, 2021
  </template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  metaInfo: {
    title: 'Privacy policy'
  }
})
export default class Privacy extends Vue {
  
}
</script>